module.exports = __webpack_public_path__ + "img/Liberia.f323041a.svg";